var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentorRentention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    rx: 47,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33.9424,
    y: 34.9637,
    width: 26.1163,
    height: 26.1163,
    rx: 2.83805,
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4168 53.7578L43.2447 41.0767H45.4932L51.3211 53.7578H48.515L47.0041 50.2323L48.1193 51.0057H40.6186L41.7338 50.2323L40.2408 53.7578H37.4168ZM44.342 44.0446L42.0396 49.5308L41.5539 48.8293H47.184L46.6983 49.5308L44.3779 44.0446H44.342ZM52.417 53.7578V41.0767H55.2051V53.7578H52.417Z",
    fill: "#4F449B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8994 47.6132H78.478",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5908 33.7137L46.5908 16.1351",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5908 61.9213L46.5908 79.4999",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6924 47.6132L15.1138 47.6132",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8994 39.437H71.5283",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8232 33.7137L38.8232 23.0848",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1768 61.9213L55.1768 72.5502",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6924 55.7892L22.0635 55.7892",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8994 55.7892H71.5283",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1768 33.7137L55.1768 23.0848",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8232 61.9213L38.8232 72.5502",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6924 39.437L22.0635 39.437",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54.9727,
    cy: 20.8364,
    r: 1.40723,
    fill: "white",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.1855,
    cy: 55.5848,
    r: 1.40723,
    transform: "rotate(90 74.1855 55.5848)",
    fill: "white",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.8145,
    cy: 39.2327,
    r: 1.40723,
    transform: "rotate(-90 19.8145 39.2327)",
    fill: "white",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.6191,
    cy: 73.1634,
    r: 1.40723,
    transform: "rotate(-180 38.6191 73.1634)",
    fill: "white",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.6191,
    cy: 20.8364,
    r: 1.40723,
    fill: "white",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.1855,
    cy: 39.2327,
    r: 1.40723,
    transform: "rotate(90 74.1855 39.2327)",
    fill: "white",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.8145,
    cy: 55.5848,
    r: 1.40723,
    transform: "rotate(-90 19.8145 55.5848)",
    fill: "white",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.9727,
    cy: 73.1634,
    r: 1.40723,
    transform: "rotate(-180 54.9727 73.1634)",
    fill: "white",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.7949,
    cy: 15.522,
    r: 1.40723,
    fill: "white",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 47.4087,
    r: 1.40723,
    transform: "rotate(90 79.5 47.4087)",
    fill: "white",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 47.4087,
    r: 1.40723,
    transform: "rotate(-90 14.5 47.4087)",
    fill: "white",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.7949,
    cy: 78.4779,
    r: 1.40723,
    transform: "rotate(-180 46.7949 78.4779)",
    fill: "white",
    stroke: "#4F449B",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentorRentention);
export default __webpack_public_path__ + "static/media/mentorRentention.6b33c1ffd3847d4bc5a8a4ff4a666438.svg";
export { ForwardRef as ReactComponent };